import { render, staticRenderFns } from "./popupMessage.vue?vue&type=template&id=79009f4e&"
import script from "./popupMessage.vue?vue&type=script&lang=js&"
export * from "./popupMessage.vue?vue&type=script&lang=js&"
import style0 from "./popupMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports